import { Tabs } from 'antd';
import useLocale from '../../../hooks/useLocale';
import { ReportType } from './constants';

import './ApplicantOrJoint.scss';

interface Props {
  reportType: ReportType;
  onToggle: (type: ReportType) => void;
  isJointFile: boolean;
}

function ApplicantOrJoint({ reportType, onToggle, isJointFile }: Props) {
  const { t } = useLocale();
  const { TabPane } = Tabs;

  return (
    <div className="ApplicantOrJoint">
      <Tabs
        activeKey={reportType === ReportType.Applicant ? 'applicant' : 'jointDebtor'}
        onChange={(key) => onToggle(key === 'applicant' ? ReportType.Applicant : ReportType.JointDebtor)}
        destroyInactiveTabPane
      >
        <TabPane
          key="applicant"
          tab={<div className="ApplicantOrJoint__tab">{t.ADMIN_INFO_TR_APPLICANT}</div>}
        ></TabPane>
        {isJointFile && (
          <TabPane key="jointDebtor" tab={<div className="ApplicantOrJoint__tab">{t.JOINT_DEBTOR}</div>}></TabPane>
        )}
      </Tabs>
    </div>
  );
}

export default ApplicantOrJoint;
